import React from 'react';
import './RatingZone.css';

export type RatingZoneRating = 'hard' | 'medium' | 'easy';

export interface RatingZoneProps {
  /** Rating type */
  rating: RatingZoneRating;
  /** Click handler */
  onClick: () => void;
  /** Whether this zone is visible */
  visible?: boolean;
  /** Additional CSS class */
  className?: string;
}

const RATING_CONFIG: Record<RatingZoneRating, { label: string }> = {
  hard: { label: 'Hard' },
  medium: { label: 'Medium' },
  easy: { label: 'Easy' },
};

/**
 * Large clickable rating zone for desktop.
 * Styled similarly to skip zone - shows label on hover.
 */
export const RatingZone: React.FC<RatingZoneProps> = ({
  rating,
  onClick,
  visible = true,
  className = '',
}) => {
  const config = RATING_CONFIG[rating];

  if (!visible) return null;

  return (
    <button
      className={`stc-rating-zone stc-rating-zone--${rating} ${className}`}
      onClick={onClick}
      aria-label={`Rate as ${config.label}`}
      type="button"
    >
      <span className="stc-rating-zone__label">{config.label}</span>
    </button>
  );
};
